import {Component, Input, OnInit} from '@angular/core';
import {ProgressBarMode} from "@angular/material/progress-bar";

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnInit {

  @Input() mode: ProgressBarMode = "determinate";
  @Input() color: ProgressBarType = "primary";
  @Input() value : number;
  constructor() { }

  ngOnInit(): void {
  }

}

export declare type ProgressBarType = 'primary' | 'warn' | 'error' | undefined;
